import { Routes } from '@angular/router';
import { riskManagerGuard } from '@core/guards/risk-manager.guard';

export const sectorRoutes: Routes = [
  {
    path: 'sectors',
    loadComponent: () => import('./sectors.component').then(m => m.SectorsComponent),
    canActivate: [riskManagerGuard],
  },
  {
    path: 'sectors/new',
    loadComponent: () => import('./new-sector/new-sector.component').then(m => m.NewSectorComponent),
    canActivate: [riskManagerGuard],
  },
];
